import type { ReactNode } from 'react';

/**
 * The standard page heading: display-font title, muted subtitle, right-aligned
 * actions. Every area page starts with one so headings never drift per module.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  breadcrumb,
}: {
  title: string;
  subtitle?: string | undefined;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
}): ReactNode {
  return (
    <header className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        {breadcrumb ? <div className="mb-1 text-xs text-ink-muted">{breadcrumb}</div> : null}
        <h1 className="font-display text-2xl font-semibold tracking-tight text-ink">{title}</h1>
        {subtitle ? <p className="mt-1 max-w-2xl text-sm text-ink-muted">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}
